<template>
	<c-dialog ref="dialog" height="400" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="属性名称" required tip="属性名称不允许重复">
				<c-input name="attribute_name" maxlength="20"></c-input>
			</c-form-item>
      <c-form-item label="属性类型" required tip="选项类型属性，请在【属性值】管理功能中添加可选的属性值，其他类型属性将在完善产品资料时录入数据">
        <c-select name="attribute_type" v-model="attributeType" :options="attributeTypeOptions" :disabled="editState"></c-select>
      </c-form-item>
      <c-form-item v-show="attributeType == 3" label="时间格式" required tip="输入时间时的时间格式">
        <c-select name="format" :options="timeFormatOptions" :clear="false"></c-select>
      </c-form-item>
      <c-form-item v-show="attributeType == 2" label="小数位数" required tip="输入数字时代，最多支持输入的小数位数；填写0表示只能输入整数">
        <c-input name="decimal" type="stepper" step-controls="side" range="0,5" append-text="位" :clear="false"></c-input>
      </c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
    ...mapState(['attributeTypeOptions','timeFormatOptions'])
  },
	
	data() {
		return {
			  editState: false,
        attributeType:4
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			if (data) {
          this.attributeType = data.attribute_type;
          //赋值已选中的属性
          setTimeout(() => {
            //合并对象
            const mergedObj = Object.assign({},data, data.config_json);
            //采购订单基本信息
            this.$refs.form.set(mergedObj);
          }, 50);
			}else {
          this.$refs.form.set({
            attribute_type:this.attributeType
          });
      }
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑属性' : '添加属性'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/spu/attribute/edit':'/spu/attribute/add',
				rule: {
          attribute_name: '请选输入属性名称',
          attribute_type: '请选输入属性类型',
          format: [{
              type: 'empty',
              message: '请选择时间格式',
              skip: () => {
                return this.attributeType != 3;
              }
          }],
          decimal: [{
              type: 'empty',
              message: '请输入数字做大允许输入的小数位数',
              skip: () => {
                return this.attributeType != 2;
              }
          }],
        },
				dataFormatter: data => {
          let config_json = {};
          if (this.attributeType == 3){//时间格式
            config_json.format = data.format;
          }else if (this.attributeType == 2){//小数位数
            config_json.decimal = data.decimal;
          }
          data.config_json = JSON.stringify(config_json);
					return data;
				},
				success: (data, res) => {
					next();
					if(this.editState){
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>